import React, { useState, useEffect } from "react";

const OSvsApplications = () => {
  const initialItems = [
    { name: "Windows", type: "OS" },
    { name: "Linux", type: "OS" },
    { name: "macOS", type: "OS" },
    { name: "Word", type: "App" },
    { name: "Chrome", type: "App" },
    { name: "Calculator", type: "App" },
    { name: "Minecraft", type: "App" },
    { name: "Photoshop", type: "App" },
    { name: "Android", type: "OS" },
    { name: "Spotify", type: "App" },
    { name: "Ubuntu", type: "OS" },
    { name: "Zoom", type: "App" }
  ];

  const [items, setItems] = useState([]);
  const [score, setScore] = useState(0);
  const [draggedItem, setDraggedItem] = useState(null);

  // Shuffle items
  const shuffle = (array) => array.sort(() => Math.random() - 0.5);

  useEffect(() => {
    setItems(shuffle([...initialItems]));
  }, []);

  const allowDrop = (e) => e.preventDefault();

  const dragStart = (item) => setDraggedItem(item);

  const dropItem = (category) => {
    if (!draggedItem) return;

    if ((category === "OS" && draggedItem.type === "OS") ||
        (category === "App" && draggedItem.type === "App")) {
      setItems((prev) =>
        prev.map((it) =>
          it.name === draggedItem.name ? { ...it, placed: true, category } : it
        )
      );
      setScore((prev) => prev + 1);
      setDraggedItem(null);
      if (score + 1 === initialItems.length) {
        setTimeout(() => alert("🎉 Amazing! You placed all items correctly! 🎉"), 100);
      }
    } else {
      // Incorrect: flash shake
      setItems((prev) =>
        prev.map((it) =>
          it.name === draggedItem.name ? { ...it, shake: true } : it
        )
      );
      setTimeout(() => {
        setItems((prev) =>
          prev.map((it) =>
            it.name === draggedItem.name ? { ...it, shake: false } : it
          )
        );
      }, 500);
      setDraggedItem(null);
    }
  };

  // --- Styles ---
  const styles = {
    body: { fontFamily: "'Comic Neue', cursive", margin: 0, padding: 0, background: "radial-gradient(circle at top left, #fff59d, #ffe57f, #ffcc80)", minHeight: "100vh" },
    h1: { textAlign: "center", fontSize: "2.2em", marginTop: 20, color: "#ff4081", textShadow: "2px 2px #fff", animation: "wave 2s infinite alternate" },
    container: { display: "flex", justifyContent: "center", flexWrap: "wrap", margin: "30px 10px", gap: 20 },
    dropzone: { width: 250, minHeight: 300, border: "4px inset #ff6f00", borderRadius: 20, padding: 10, background: "linear-gradient(145deg, #ffd54f, #fff8e1)", boxShadow: "4px 4px 12px rgba(0,0,0,0.2)", transition: "transform 0.2s", position: "relative" },
    dropzoneH3: { marginTop: 0, color: "#e65100", fontSize: "1.3em", textShadow: "1px 1px #fff" },
    itemsContainer: { display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: 20, gap: 12 },
    draggable: { padding: "12px 18px", borderRadius: 12, borderStyle: "outset", background: "#ffcc80", color: "#3e2723", fontWeight: "bold", cursor: "grab", boxShadow: "2px 2px 8px rgba(0,0,0,0.2)", transition: "all 0.3s", fontSize: "0.95em" },
    correct: { background: "#4caf50", color: "white", cursor: "default", boxShadow: "0 0 15px 5px #ffff00", animation: "sparkle 0.6s ease" },
    shake: { animation: "shake 0.5s", background: "#e57373", color: "white" },
    score: { fontSize: "1.5em", fontWeight: "bold", marginTop: 20, textAlign: "center", color: "#ff5722", textShadow: "1px 1px #fff" }
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>💻 OS vs Applications</h1>

      <div style={styles.container}>
        <div
          style={styles.dropzone}
          onDragOver={allowDrop}
          onDrop={() => dropItem("OS")}
        >
          <h3 style={styles.dropzoneH3}>🖥️ Operating System</h3>
          {items.filter(it => it.placed && it.category === "OS").map(it => (
            <div key={it.name} style={{...styles.draggable, ...styles.correct}}>{it.name}</div>
          ))}
        </div>

        <div
          style={styles.dropzone}
          onDragOver={allowDrop}
          onDrop={() => dropItem("App")}
        >
          <h3 style={styles.dropzoneH3}>📱 Application</h3>
          {items.filter(it => it.placed && it.category === "App").map(it => (
            <div key={it.name} style={{...styles.draggable, ...styles.correct}}>{it.name}</div>
          ))}
        </div>
      </div>

      <h4 style={{ textAlign: "center" }}>Drag the items into the correct category!</h4>

      <div style={styles.itemsContainer}>
        {items.filter(it => !it.placed).map(item => (
          <div
            key={item.name}
            draggable
            onDragStart={() => dragStart(item)}
            style={{
              ...styles.draggable,
              ...(item.shake ? styles.shake : {})
            }}
          >
            {item.name}
          </div>
        ))}
      </div>

      <div style={styles.score}>Score: {score} / {items.length}</div>

      {/* Keyframes for animations */}
      <style>
        {`
          @keyframes wave { 0% { transform: rotate(-2deg); } 50% { transform: rotate(2deg); } 100% { transform: rotate(-2deg); } }
          @keyframes shake { 0% { transform: translateX(0); } 25% { transform: translateX(-5px); } 50% { transform: translateX(5px); } 75% { transform: translateX(-5px); } 100% { transform: translateX(0); } }
          @keyframes sparkle { 0% { box-shadow: 0 0 10px #ffff00; } 50% { box-shadow: 0 0 20px #fff700; } 100% { box-shadow: 0 0 10px #ffff00; } }
        `}
      </style>
    </div>
  );
};

export default OSvsApplications;
